module.exports = __webpack_public_path__ + "static/img/logo.4eadd2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/image/logo.png
// module id = 6950
// module chunks = 1